import { all } from "redux-saga/effects";
import watchFetchBOCDeviceConnectionService from "./CSAgentPortal/BOC/BOCDeviceConnectionServiceSaga";
import watchFetchDisconnectBOCOnlineFunctionsService from "./CSAgentPortal/BOC/DisconnectBOCOnlineFunctionsServiceSaga";

export default function* CSAgentPortalSagasRTKIndex() {
    yield all([
        watchFetchBOCDeviceConnectionService(),
        watchFetchDisconnectBOCOnlineFunctionsService()
    ])
}